import url from '../url'
import headers from '../headers'
import moment from 'moment'

export default {
	getLast (context, user_uid, watch_id) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/readings/lasts/`,
			headers.bearer()
		)
	},
	getAllByType (context, user_uid, watch_id, type_id, offset = 0, size = 999) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/readings/${type_id}/?offset=${offset}&size=${size}`,
			{
				...headers.bearer(),
				// Abort a previous request when a new request is about to be sent.
				// Useful when the user changes to new reading type page before data arrives.
				// https://github.com/pagekit/vue-resource/blob/develop/docs/recipes.md#abort-a-request
				before(request) {
					if (this.previousRequest) this.previousRequest.abort()
					this.previousRequest = request
				}
			}
		)
	},
	getByID (context, user_uid, watch_id, type_id, reading_id) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/readings/${type_id}/reading/${reading_id}/`,
			headers.bearer()
		)
	},
	getAllByTypeBetweenDates (context, user_uid, watch_id, type_id, date_start, date_end) {
		date_start = encodeURIComponent(moment(date_start).format())
		date_end = encodeURIComponent(moment(date_end).format())
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/readings/${type_id}/interval/?start=${date_start}&end=${date_end}`,
			{
				...headers.bearer(),
				before(request) {
					if (this.previousRequest) this.previousRequest.abort()
					this.previousRequest = request
				}
			}
		)
	},
	getPositionNearDatetime (context, user_uid, watch_id, model) {
		return context.$http.post(
			`${url}/users/${user_uid}/watches/${watch_id}/readings/position/`,
			model,
			headers.bearer()
		)
	},
	types: {
		admin: {
			getAll (context, offset = 0, size = 999) {
				return context.$http.get(
					`${url}/readingtypes/?offset=${offset}&size=${size}`,
					headers.bearer()
				)
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/readings.js